import { useState, useEffect } from "react";

// Stocks -> Financial Modeling Prep (keyless, by ticker). Crypto (BASE-USD) ->
// spothq cryptocurrency-icons CDN. Falls back to a 2-letter monogram on error.
export function AssetLogo({ ticker, size = 22, logo }) {
  const [err, setErr] = useState(false);
  useEffect(() => { setErr(false); }, [ticker, logo]);

  const isCrypto = !!ticker && /USD$/.test(ticker) && ticker.length > 4 && ticker !== "USD";
  const base = (ticker || "").replace(/-?USD$/, "");
  const fallbackSrc = isCrypto
    ? `https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/128/color/${base.toLowerCase()}.png`
    : `https://financialmodelingprep.com/image-stock/${ticker}.png`;
  const src = logo || fallbackSrc;

  if (err || !ticker) {
    return (
      <span className="rounded-full bg-white/10 shrink-0 flex items-center justify-center mono text-muted-foreground"
        style={{ height: size, width: size, fontSize: Math.round(size * 0.36) }}>
        {base.slice(0, 2).toUpperCase()}
      </span>
    );
  }
  return (
    <img src={src} alt="" onError={() => setErr(true)} loading="lazy"
      className="rounded-full object-contain shrink-0"
      style={{ height: size, width: size, padding: isCrypto ? 0 : 2, backgroundColor: isCrypto ? "transparent" : "#fff" }} />
  );
}
